import { Box, FormControl, TextField, Typography } from '@mui/material';
import React from 'react';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { PasswordTabProps } from './types';

const PasswordTab: React.FC<
 PasswordTabProps & { onSubmit: (e?: React.BaseSyntheticEvent) => Promise<void> }
> = ({ control, errors, watch, onSubmit }) => {
 const { t } = useTranslation();
 return (
  <form id="password-change-form" onSubmit={onSubmit}>
   <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
    <Typography
     sx={{
      fontSize: '14px',
      color: (th) => th.palette.kemek.darkGray,
      fontWeight: 500,
     }}
    >
     {t('user.password.changeTitle')}
    </Typography>

    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
     <FormControl fullWidth error={!!errors.currentPassword}>
      <Controller
       name="currentPassword"
       control={control}
       rules={{ required: t('user.errors.required', { field: t('user.password.current') }) }}
       render={({ field }) => (
        <TextField
         {...field}
         id="currentPassword"
         type="password"
         label={t('user.password.current')}
         variant="outlined"
         error={!!errors.currentPassword}
         helperText={errors.currentPassword?.message}
         sx={{ backgroundColor: (th) => th.palette.background.paper }}
        />
       )}
      />
     </FormControl>

     <FormControl fullWidth error={!!errors.newPassword}>
      <Controller
       name="newPassword"
       control={control}
       rules={{
        required: t('user.errors.required', { field: t('user.password.new') }),
        minLength: {
         value: 8,
         message: t('user.errors.minLength', { min: 8 }),
        },
       }}
       render={({ field }) => (
        <TextField
         {...field}
         id="newPassword"
         type="password"
         label={t('user.password.new')}
         variant="outlined"
         error={!!errors.newPassword}
         helperText={errors.newPassword?.message}
         sx={{ backgroundColor: (th) => th.palette.background.paper }}
        />
       )}
      />
     </FormControl>

     <FormControl fullWidth error={!!errors.repeatPassword}>
      <Controller
       name="repeatPassword"
       control={control}
       rules={{
        required: t('user.errors.repeatPassword'),
        validate: (value) =>
         value === watch('newPassword') || t('user.errors.passwordsMatch'),
       }}
       render={({ field }) => (
        <TextField
         {...field}
         id="repeatPassword"
         type="password"
         label={t('user.password.repeat')}
         variant="outlined"
         error={!!errors.repeatPassword}
         helperText={errors.repeatPassword?.message}
         sx={{ backgroundColor: (th) => th.palette.background.paper }}
        />
       )}
      />
     </FormControl>
    </Box>
   </Box>
  </form>
 );
};

export default PasswordTab;

